module.exports = __webpack_public_path__ + "img/retailer_item_remove.5e8aa989.svg";